import React from 'react';

const HeadingBlock = ({ data, onChange }) => {
  return (
    <div className="basic-form">
      <div className="mb-3">
        <label className="form-label">Heading Level</label>
        <select
          className="form-select"
          value={data.level}
          onChange={(e) => onChange({ ...data, level: e.target.value })}
        >
          <option value="h1">Heading 1 (H1)</option>
          <option value="h2">Heading 2 (H2)</option>
          <option value="h3">Heading 3 (H3)</option>
          <option value="h4">Heading 4 (H4)</option>
          <option value="h5">Heading 5 (H5)</option>
          <option value="h6">Heading 6 (H6)</option>
        </select>
      </div>
      <div className="mb-3">
        <label className="form-label">Heading Text</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter heading text..."
          value={data.text}
          onChange={(e) => onChange({ ...data, text: e.target.value })}
        />
      </div>
    </div>
  );
};

export default HeadingBlock;
